// extracted by mini-css-extract-plugin
export var BodyText = "BodyText-module--BodyText--zJEoF";
export var aniSpin = "BodyText-module--ani-spin--Ulb6F";
export var column = "BodyText-module--column--1zUy6";
export var container = "BodyText-module--container--vWP8h";